import { z } from "zod";

import { API_VERSION } from "./common";

export const MAX_UPLOAD_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const SUPPORTED_IMAGE_CONTENT_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif",
] as const;

export const uploadIntentRequestSchema = z
  .object({
    contentLength: z.number().int().positive().max(MAX_UPLOAD_IMAGE_SIZE_BYTES),
    contentType: z.enum(SUPPORTED_IMAGE_CONTENT_TYPES),
    purpose: z.enum(["recipe", "avatar"]),
  })
  .strict();

export const uploadIntentResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: z.object({
    expiresAt: z.string().datetime(),
    headers: z.record(z.string(), z.string()),
    method: z.literal("PUT"),
    publicUrl: z.string().url(),
    signedUrl: z.string().url(),
  }),
});

export type UploadIntentRequest = z.input<typeof uploadIntentRequestSchema>;
export type ParsedUploadIntentRequest = z.output<
  typeof uploadIntentRequestSchema
>;
export type UploadIntentResponse = z.infer<typeof uploadIntentResponseSchema>;
